import Aegis from '@tencent/aegis-web-sdk';
import { NoReportError } from './error';
import { EventLog, NormalLog } from '@tencent/aegis-web-sdk/lib/packages/core/src/interface/log';

let aegisId;
// H5 和 PC 端获取环境变量方式不一样

try {
  aegisId = process.env.VUE_APP_AEGIS_ID;
} catch (error) {
  throw new Error('aegis id 获取失败');
}

export const updateUin = (uid: number | string): void => {
  aegis.setConfig({
    uin: uid.toString(),
  });
};

interface ReportData {
  logType: string;
  logs: EventLog | NormalLog
}


export const aegis = new Aegis({
  id: aegisId, // 项目key
  // uin: Cookies.get('uid'), // 用户唯一 ID（可选）初始化时没有uid，等待更新
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 页面需要开启，页面切换的时候上报pv
  offlineLog: true, // 开启离线日志

  beforeRequest(data: ReportData) {
    // 过滤不需要上报的业务错误
    if (data.logType === 'log' && (data.logs as NormalLog).msg.includes(NoReportError.tag)) {
      return false;
    }
    // 过滤非前端业务出现的错误
    if (data.logType === 'log' && (data.logs as NormalLog).msg.includes('Script error. @ (:0:0)')) {
      return false;
    }
    return data;
  },
});

